import React from 'react'
import Login from '../component/login/Login'

const Logo = () => {
  return (
    <Login />
  )
}

export default Logo